import { memo, useEffect } from 'react';
import { InboxMessageList } from '../components';
import { useDispatch } from '@betty/toolkit/state';
import { acknowledgeInbox } from '../state/inbox.slice';

function InboxModal() {
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(acknowledgeInbox());
    };
  }, [dispatch]);

  return <InboxMessageList />;
}

export default memo(InboxModal);
